<template>
  <div />
</template>

<script>
import { onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();

    onMounted(async () => {
      ({
        device_token: composable.member.deviceToken,
        os: composable.member.os,
      } = route.params);

      const cmd = spiderman.generate.specialCommand({
        cmd: 'ready',
        timestamp: spiderman.generate.timestamp(),
      });

      if (route.params.openMode === 'notification') {
        router.replace({
          path: '/auth/notification',
          query: route.query,
          hash: `#inncom#${cmd}`,
        });
      } else {
        router.replace({
          path: '/auth',
          hash: `#inncom#${cmd}`,
        });
      }
    });

    return {
      composable,
    };
  },
};
</script>
